<template>
  <el-dialog
    :modal="true"
    :modal-append-to-body="true"
    :title="title"
    :visible.sync="show"
    :close-on-click-modal="false"
    :show-close="true"
    :close-on-press-escape="true"
    :before-close="clickCancel"
    width="600px" class="add_company_dialog">
    <el-form :model="newCompanyForm" :rules="rules" ref="newCompanyForm" class="newCompanyForm">
      <div class="dialog_head">
        <el-form-item prop="companyName" label="公司名称">
          <el-input v-model.trim="newCompanyForm.companyName" autocomplete="off" placeholder="请输入公司名称" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item prop="companyCode" label="公司编码">
          <el-input v-model.trim="newCompanyForm.companyCode" autocomplete="off" placeholder="请输入公司编码" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item prop="useScope" label="使用范围">
          <el-select placeholder="请选择使用范围" multiple v-model="newCompanyForm.useScope">
            <el-option
              v-for="item in useScopeOptions"
              :key="item.id"
              :label="item.labelName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="clickCancel">取消</el-button>
      <el-button type="primary" @click="submitForm('newCompanyForm')">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '标题'
    },
    newCompanyForm: {
      type: Object,
      default: function(){
        return {
          companyName:'',
          companyCode:'',
          useScope: []
        }
      }
    },
    showModalconfirm:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      show:false,
      rules: {
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          // { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        companyCode:[
          { required: true, message: '请输入公司编码', trigger: 'blur' }
        ],
        useScope:[
          { type: 'array', required: true, message: '请选择使用范围', trigger: 'change' }
        ],
      },
      useScopeOptions:[]
    }
  },
  created() {
    this.getScope()
  },
  methods: {
    getScope(){
      this.$ajax.get('/api-resource/question/findLabel').then(rs=>{
        console.log(rs)
        if(rs.data.code==0){
          this.useScopeOptions = rs.data.data
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    clickCancel(){
      this.show = false
      this.$emit('cancelAddCompany')
      this.resetForm('newCompanyForm')
    },
    submitForm(formName){
      this.$refs[formName].validate((valid, formdata) => {
        if (valid) {
          this.$emit('confirmAddCompany',this.newCompanyForm);
          this.resetForm(formName)
        }else{
          console.log('error')
          return false
        }
      })
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  watch:{
    showModalconfirm(val){
      this.show = val
    }
  }
}
</script>
<style lang="scss">
  .add_company_dialog{
    .newCompanyForm{
      width: 340px;
      margin: 30px auto 0;
    }
    .el-form-item{
      .el-form-item__label{
        font-size:14px;
        font-weight:400;
        line-height: 34px;
        color:rgba(51,51,51,1);
      }
      .el-form-item__content{
        .el-input{
          width: 260px;
          .el-input__inner{
            height: 34px;
            line-height: 34px;
          }
        }
        .el-form-item__error{
          margin-left: 80px;
        }
      }
    }
    .el-dialog__footer{
      padding-bottom: 48px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/educationalAdmin/educationalAdminMenu/subjectDialog/addCompanyDialog.vue